import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getSalesPersonUsers = createAsyncThunk(
  "salesPerson/get",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      params.append("pageNumber", payload.PageNumber || 1);
      params.append("pageSize", payload.PageSize || 30);
      if (payload.searchText) {
        params.append("searchText", payload.searchText);
      }

      const { data } = await axios.get(
        `${API_URL.CUSTOMER.GET_SALES_PERSONS}?${params.toString()}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const salesPersonSlice = createSlice({
  name: "salesPerson",
  initialState: {
    sales_person_list: [],
  },
  reducers: {
    resetSalesPersonList(state) {
      state.sales_person_list = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSalesPersonUsers.fulfilled, (state, action) => {
      state.sales_person_list = action.payload.data.list;
    });
  },
});

export const { resetSalesPersonList } = salesPersonSlice.actions;
export default salesPersonSlice.reducer;
